import { useState } from 'react'

export function useRebeepState() {
  const statesFactories = {
    INITIAL: () => ({}),
    SHOWING_MODAL_PLEASE_REBEEP: () => ({ isModalRebeepOpen: true }),
    WAITING_SECOND_BEEP: (lastBarcode) => ({ lastBarcode }),
    SHOWING_MODAL_WRITE_DESCRIPTION: () => ({
      isModalWriteDescriptionOpen: true
    }),
    WAITING_DESCRIPTION: () => ({ descriptionIsWritable: true })
  }

  const [rebeepState, setRebeepState] = useState(statesFactories.INITIAL())

  function changeRebeepState(stateName, ...args) {
    setRebeepState(statesFactories[stateName](...args))
  }

  return { rebeepState, changeRebeepState }
}
